import { GetDefaultPlaygroundModeParams, PlaygroundMode } from '../types';

const getDefaultPlaygroundMode = ({ trigger }: GetDefaultPlaygroundModeParams): PlaygroundMode => {
    return trigger?.type === 'ag-ui-trigger' ? 'chat' : 'graph';
};

export default getDefaultPlaygroundMode;
